import api from './api.js';

export const folioRealService = {
  buscar: (params) => api.get('/folio-real/buscar', { params }),
  show: (idFolioReal) => api.get(`/folio-real/${idFolioReal}`),
};